<template>
  <v-row class="ma-0 pa-0 pb-2">
    <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="pl-0">
      <v-sheet
        v-if="fetchingProfile"
        elevation="2"
        class="py-4 px-6"
        style="height: 100%"
      >
        <v-skeleton-loader type="text" width="100" />
        <v-skeleton-loader type="text@4" width="200" class="mt-4" />
      </v-sheet>
      <v-sheet v-else rounded elevation="2" class="py-4 px-6">
        <p class="ma-0 pa-0 mb-5 subtitle-2" style="font-weight: 700">
          {{ $t('common.users.personal_info') }}
        </p>
        <div
          class="d-flex mb-4 align-center"
          v-if="profileAccount.displayname || profileAccount.familyname"
        >
          <v-icon size="24" class="me-4" color="blue-grey"
            >mdi-account-outline</v-icon
          >
          <p class="ma-0 pa-0 body-2">{{ getFullName(profileAccount) }}</p>
        </div>
        <div class="d-flex align-center" v-if="profileAccount.email">
          <v-icon size="24" class="me-4" color="blue-grey"
            >mdi-email-outline
          </v-icon>
          <p class="ma-0 pa-0 body-2" data-private>
            {{ profileAccount.email }}
          </p>
        </div>
        <div
          class="d-flex align-center mt-4"
          v-if="profileAccount.organization"
        >
          <v-icon size="24" class="me-4" color="blue-grey"
            >mdi-warehouse</v-icon
          >
          <p class="ma-0 pa-0 body-2" data-private>
            {{ organizationName }}{{ siteName }}
          </p>
        </div>
      </v-sheet>
      <AdminSitesCard
        data-testid="aboutTab-adminSitesCard-card"
        :fetchingProfile="fetchingProfile"
        :profileAccount="profileAccount"
      />
      <v-sheet
        v-if="fetchingProfile"
        elevation="2"
        class="mt-4 py-4 px-6"
        style="height: 100%"
      >
        <v-skeleton-loader type="text" width="100" />
        <v-skeleton-loader type="text@4" width="200" class="mt-4" />
      </v-sheet>
      <v-sheet
        v-else-if="!fetchingProfile && showTags"
        rounded
        elevation="2"
        class="mt-4 py-4 px-6"
      >
        <p class="ma-0 pa-0 mb-5 subtitle-2" style="font-weight: 700">
          {{ $t('common.tag_other') }}
        </p>

        <div class="d-flex align-start">
          <div>
            <v-icon size="24" class="me-4" color="blue-grey">
              mdi-tag-outline
            </v-icon>
          </div>
          <div class="d-flex flex-wrap">
            <v-chip
              v-for="tag in profileAccount.tags"
              small
              outlined
              class="me-1 mb-1"
              :key="tag.id"
            >
              {{ tag.name }}
            </v-chip>
          </div>
        </div>
      </v-sheet>
    </v-col>
    <v-col
      cols="12"
      md="6"
      lg="6"
      xl="6"
      :class="{
        'mt-2': $vuetify.breakpoint.mobile,
      }"
      class="pr-0"
    >
      <v-sheet rounded elevation="2" class="py-4 px-4">
        <Teams
          :profileAccount="profileAccount"
          :fetchingProfile="fetchingProfile"
        />
        <Skills
          class="mt-6"
          :isSelfProfile="isSelfProfile"
          :skills="skills"
          :fetchingProfile="fetchingProfile"
        />
      </v-sheet>
    </v-col>
  </v-row>
</template>

<script>
import userMixin from '@/mixins/userMixin.vue'
import AdminSitesCard from './AdminSitesCard.vue'
import Skills from './Skills.vue'
import Teams from './Teams.vue'

export default {
  name: 'About',

  mixins: [userMixin],

  components: {
    AdminSitesCard,
    Skills,
    Teams,
  },

  props: {
    profileAccount: {
      type: Object,
      required: true,
    },
    isSelfProfile: {
      type: Boolean,
      required: true,
    },
    fetchingProfile: {
      type: Boolean,
      required: true,
    },
  },

  computed: {
    showTags() {
      return Boolean(this.profileAccount?.tags?.length)
    },

    skills() {
      return this.profileAccount?.skills ?? []
    },

    organizationName() {
      return this.profileAccount?.organization?.name ?? ''
    },

    siteName() {
      return this.profileAccount?.site?.name
        ? `, ${this.profileAccount?.site?.name}`
        : ''
    },
  },
}
</script>
